export default {
      id: "icon-heart-right-usage",
      viewBox: "0 0 526 682",
      url: __webpack_public_path__ + "icons.svg#icon-heart-right",
      toString: function () {
        return this.url;
      }
    }